import React, { useState } from "react";
import styled from "styled-components";
import Header from "../../partials/Header/Header";
import Menu from "../../partials/Menu/Menu";
import { withRouter } from "react-router-dom";
import Sidebar from "react-sidebar";
import withSizes from "react-sizes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTheme } from "styled-components";
import { getCurrentSite } from "../../../lib/helpers";

const Root = styled.div`
  width: 100%;
  display: flex;
  background-color: #eaeaea;
  .sidikbar {
    z-index: 2000;
  }
  .rdw-list-dropdown {
    z-index: 1;
  }
`;
const Content = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  min-height: 100vh;
  margin-bottom: 100px;
`;

const MobileMenu = styled.div`
  padding: 0 30px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  @media (min-width: 701px) {
    display: none;
  }
  background-color: ${props => props.theme.color1};
  color: ${props => props.theme.color2};
  button {
    background-color: ${props => props.theme.color1};
  }
`;

export default withTheme(
  withSizes(({ width }) => ({
    isMobile: width < 701
  }))(
    withRouter(({ children, location, isMobile, theme }) => {
      const menue = [
        "company",
        "lesson",
        "schedule",
        "booking",
        "publish",
        "statistic"
      ];
      let selected = "";
      menue.forEach(m => {
        if (location.pathname.indexOf(m) >= 0) {
          selected = m;
        }
      });
      const [menuOpened, setMenuOpened] = useState(false);
      console.log("OPENED", menuOpened);
      return (
        <Root>
          <Sidebar
            sidebarClassName={"sidikbar"}
            sidebar={<Menu selected={selected} />}
            open={menuOpened}
            docked={!isMobile}
            onSetOpen={setMenuOpened}
          >
            {isMobile && (
              <MobileMenu>
                <button onClick={() => setMenuOpened(true)}>
                  <FontAwesomeIcon
                    icon={["fas", "bars"]}
                    size="2x"
                    color={theme.color5}
                  />
                </button>
                <div>{getCurrentSite()}</div>
              </MobileMenu>
            )}
            <Content>{children}</Content>
          </Sidebar>
        </Root>
      );
    })
  )
);
